// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"73855":"d63f83bbc2c608fc","75409":"589d8a59a4be3154","90269":"e3ca36435cb7915e"}[chunkId] + ".css";
};